import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useAreas } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { PageHero, CTABand, usePageTitle } from "@/components/site/Bits";

export default function Areas() {
  usePageTitle("Áreas de Atuação");
  const areas = useAreas();

  return (
    <>
      <PageHero
        title="Áreas de Atuação"
        text="Escopo de serviços, problemas jurídicos que podem envolver cada situação e as formas de atuação do escritório."
        overline="Silva Cotan e Associados — Assessoria Jurídica"
      />

      <section className="bg-ivory">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          {areas.length === 0 && (
            <p className="border border-dashed border-navy/20 px-8 py-10 text-sm text-inkgray">As áreas de atuação serão publicadas em breve.</p>
          )}
          {areas.map((area, i) => (
            <Reveal key={area.slug} delay={0.05 * i}>
              <Link
                to={`/areas-de-atuacao/${area.slug}`}
                data-testid={`areas-row-${area.slug}`}
                className="group grid grid-cols-[64px_1fr_48px] items-start gap-6 border-t border-navy/10 py-10 transition-colors md:grid-cols-[120px_1fr_auto] md:gap-10 md:py-14"
              >
                <span className="font-display text-3xl italic text-gold md:text-5xl">0{area.order || i + 1}</span>
                <div>
                  <h2 className="font-display text-2xl text-navy transition-colors group-hover:text-gold-deep md:text-4xl">{area.title}</h2>
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-inkgray md:text-base">{area.summary}</p>
                </div>
                <span className="mt-2 flex h-11 w-11 items-center justify-center border border-navy/15 text-navy transition-all duration-300 group-hover:border-gold group-hover:bg-gold md:mt-6">
                  <ArrowUpRight size={17} strokeWidth={1.5} />
                </span>
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-navy/10" />
        </div>
      </section>

      <CTABand title="Não encontrou a sua demanda? Fale com a gente." button="Entrar em contato" />
    </>
  );
}
